import { PanelType } from '../utils/Constants';

export const usePanelType = () => {
  const panelType = process.env.REACT_APP_PANEL_TYPE;
  return panelType || PanelType.DIRECTA;
};
